import { useQuery } from "react-query";
import { getMediaLimit } from "../api";
import { useToken } from "./useToken";

export const useMediaLimit = () => {
  const { token } = useToken();
  return useQuery("getMediaLimit", () => getMediaLimit({ token }));
};
